module.exports = __webpack_public_path__ + "static/img/guaibao_03.ead4331.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/guaibao_03.png
// module id = 9i+L
// module chunks = 0